import { createSlice } from '@reduxjs/toolkit';

export interface SideMenuState {
  isDisplayed: boolean,
  isExpanded: boolean
}

const initialState: SideMenuState = {
  isDisplayed: false,
  isExpanded: false
};

const sideMenuSlice = createSlice({
  name: 'sideMenu',
  initialState,
  reducers: {
    collapse(state) {
      state.isExpanded = false;
    },
    display(state) {
      state.isDisplayed = true;
    },
    expand(state) {
      state.isExpanded = true;
    },
    hide(state) {
      state.isDisplayed = false;
    }
  }
});

export const sideMenuActions = sideMenuSlice.actions;
export default sideMenuSlice;
